module.exports = __webpack_public_path__ + "static/onmymind_obj2@2x-bdcbaa9eeea622b4e8b1895cfa0b8165.png";